import {RootState, getLastSelectedWorkspaceReservationLocation} from '../../..';
import {Attendee} from './getAttendeeOverview';
import {OfficeWorkday, WorkspaceReservation} from '../apiTypes';

// TODO: closed / capacity 0 / full checks
// This is built to mimic the `getInitialSelectedWorkspace` selector
export const getInitialWorkspaceSelection = (
  state: RootState,
  workday: OfficeWorkday,
  workspaceReservation?: WorkspaceReservation,
  members: Array<Attendee> = [],
) => {
  // If editing a reservation, return that reservation's locations
  if (workspaceReservation) {
    const {workspace} = workspaceReservation;
    return {
      buildingId: workspace.buildingId,
      // TODO: defaulting to empty string hurts, but I'm going for backwards compatabiltiy here...
      floorId: 'floorId' in workspace ? workspace.floorId : '',
      areaId: 'areaId' in workspace ? workspace.areaId : '',
      deskIds: members.flatMap((m) =>
        m.reservation.workspace.nodeType === 'Desk' ? [m.reservation.workspace.deskId] : [],
      ),
    };
  }

  // If last selection from local storage is in workday building, use that
  const lastUsed = getLastSelectedWorkspaceReservationLocation(state);
  if (lastUsed.buildingId === workday.buildingId) {
    return {
      buildingId: lastUsed.buildingId,
      floorId: lastUsed.floorId,
      areaId: lastUsed.areaId,
      deskIds: lastUsed.deskId ? [lastUsed.deskId] : [],
    };
  }

  // if no smart suggestions can be resolved (e.g. first use of app), return just workday's building id
  return {
    buildingId: workday.buildingId,
  };
};
